import React, {useEffect, useState} from 'react'
import {Accordion} from 'react-bootstrap';
import {MDBDataTable} from 'mdbreact';
import axios from "axios";
import toast from 'react-hot-toast';
import {useLocation} from "react-router-dom";
//mqtt conf
import Paho from 'paho-mqtt';


let messageCount = 0;

const LocalWaitTicketModal = ({ showAddWaitTicketModal, setShowAddWaitTicketModal, userBid,branchData }) => {
    let client = null;

    let configs = JSON.parse(localStorage.getItem("configuration_data"));
    const location = useLocation();

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    
    const selectedBranchId = location.state.selectedBranchId;

    // const [localWaitTicket, setLocalWaitTicket] = useState([]);
    // const [allStatusList, setAllStatusList] = useState([]);

    const [allOperatorStatusList, setAllOperatorStatusList] = useState([]);
    const [operatorStatus, setOperatorStatus] = useState([]);

    //table body
    const body = {
        columns: [
            {
                label: 'Token',
                field: 'token',
                width: 0,
            },
            {
                label: 'Category',
                field: 'category',
                width: 0,
            },
            {
                label: 'Waiting Start',
                field: 'waitingStart',
                width: 0,
            },
            {
                label: 'Waiting End',
                field: 'waitingEnd',
                width: 0,
            },
            {
                label: 'Counter',
                field: 'counter',
                width: 0,
            },
            {
                label: 'User',
                field: 'user',
                width: 0,
            },
            {
                label: 'Status',
                field: 'statustext',
                width: 0,
            },
            {
                label: 'Reason',
                field: 'reason',
                width: 0,
            },
        ],
        rows: allOperatorStatusList,
    };

    //operatorStatus - useEffect
    useEffect(() => {
        let postsArray = JSON.parse(JSON.stringify(operatorStatus));
        let userData = [];
        postsArray.map((item, index) => {

            item.statustext = (
                <>
                    {item.status === -1 ? (
                        <p className='mb-0'>transferred</p>
                    ) : item.status === 0 ? (
                        <p className='mb-0'>pending</p>
                    ) : item.status === 1 ? (
                        <p className='mb-0'>serving</p>
                    ) : item.status === 2 ? (
                        <p className='mb-0'>noshow</p>
                    ) : item.status === 3 ? (
                        <p className='mb-0'>waiting</p>
                    ) : item.status === 4 ? (
                        <p className='mb-0'>served</p>
                    ) : item.status === 5 ? (
                        <p className='mb-0'>transferred_served</p>
                    ) : item.status === -10 ? (
                        <p className='mb-0'>lobby_main</p>
                    ) : item.status === -20 ? (
                        <p className='mb-0'>lobby_2</p>
                    ) :
                        <p className='mb-0'>deleted</p>
                    }

                </>

            )
            userData.push(item);
        });
        setAllOperatorStatusList(userData);

    }, [operatorStatus])

    //getBranchSummaryLocalWaittingTickets - useEffect
    useEffect(() => {
        // console.log('+++++++++', selectedBranchId);
        if (baseUrl.length > 0 && token.length > 0) {
            executeFunctions();
            // getBranchSummaryLocalWaittingTickets();
        }
    }, [LocalWaitTicketModal])

    //mqtt config - useEffect
    useEffect(() => {
        client = new Paho.Client(configs['ip'], Number(configs['port']), 'mqttjs_' + Math.random().toString(16).substr(2, 8));

        //set callback handlers (mqtt)
        client.onConnectionLost = onConnectionLost;
        client.onMessageArrived = onMessageArrived;
        console.log('Message count: ', messageCount);

        //connect the client (mqtt)
        client.connect({
            onSuccess: onConnect,
            userName: configs['mq-username'],
            password: configs['mq-password'],
            reconnect: true,
            useSSL: configs['use-ssl'] === 'true'
        });
        return () => {
            if (client !== null && client.isConnected()) {
                client.unsubscribe(`ticket/dashboard/branch/${selectedBranchId}`)
                client.disconnect()
                client = null;
            }
        }
    }, [LocalWaitTicketModal])


    useEffect(() => {
        // returned function will be called on component unmount
        return () => {
            if (client !== null && client.isConnected()) {
                client.unsubscribe(`ticket/dashboard/branch/${selectedBranchId}`)
                client.disconnect()
                client = null;
            }
        }
    }, []);
    //called when the client connects (mqtt)
    const onConnect = () => {
        client.subscribe(`ticket/dashboard/branch/${selectedBranchId}`);
    }


    // called when the client loses its connection (mqtt)
    const onConnectionLost = (responseObject) => {
        if (responseObject.errorCode !== 0) {
            console.log("onConnectionLost:" + responseObject.errorMessage);
        }
    }

    // called when a message arrives (mqtt)
    const onMessageArrived = (message) => {
        console.log("onMessageArrived:" + message.payloadString);

        executeFunctions(message.payloadString);
    }

    //execute all functions
    const executeFunctions = (messageData) => {
        console.log('executeFunctions start');

        if (messageData === undefined || messageData === null || messageData === '') {
            getBranchSummaryLocalWaittingTickets();


        } else {
            console.info(messageData)
            // setMessages(messageData);
            if (messageData === '1000' || '1001' || '2001' || '3000' || '3001') {
                getBranchSummaryLocalWaittingTickets();
            }
        }
    }

    //getBranchSummaryLocalWaittingTickets - function
    const getBranchSummaryLocalWaittingTickets = () => {
        console.log('getBranchSummaryLocalWaittingTickets function start');

        axios({
            method: 'GET',
            url: `${baseUrl}/real-time/get-branch-summary/local-waitings/branch/${selectedBranchId}`,
            headers: {
                Authorization: token
            }
        }).then((res) => {
            console.log('getBranchSummaryLocalWaittingTickets success');

            let dataList = res.data.data;
            console.log(dataList);
            setOperatorStatus(dataList);
            // setAllStatusList(dataList);
            // setStatus(dataList);
            // setLocalWaitTicket(dataList);

        }).catch((error) => {
            console.log('getBranchSummaryLocalWaittingTickets error');
            console.log(error);

            if (error.response !== undefined) {
                toast.remove();
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });

            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        })
    }


    //close modal - function
    const closeModal = () => {
        setShowAddWaitTicketModal(false);
    }


    return (
        <>
            {showAddWaitTicketModal ? (
                <div className={`modal fade d-block show modal-container`} id="category-modal">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Local Wait Ticket</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={() => {
                                        closeModal();
                                    }}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="row clearfix">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className='body'>

                                            <Accordion className='accordion' id="accordion" defaultActiveKey="0">
                                                <div>

                                                    <Accordion.Collapse eventKey="0" className="collapse">
                                                        <div className="accordion-body">
                                                            <div className="table-responsive ">
                                                                <MDBDataTable
                                                                    noBottomColumns
                                                                    className="table table-hover js-basic-example dataTable table-custom spacing5 action-col-align categories-table"
                                                                    displayEntries={false}
                                                                    paging
                                                                    pagesAmount={15}
                                                                    searching={false}
                                                                    data={body}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Accordion.Collapse>

                                                </div>
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='modal-footer'>
                                <button type="button" className="btn btn-default" data-dismiss="modal"
                                    onClick={() => {
                                        closeModal()
                                    }}
                                >Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            ) : null
            }
        </>

    )
}

export default LocalWaitTicketModal
